import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import Loader from "../../shared/loader";
import axios from "axios";
import moment from "moment";

const Dispatch = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [invoice, setInvoice] = useState({
        party: {},
        ship: {},
        items: [],
    });

    const getEdit = () => {
        axios.post(API_URL.INVOICE_GET, { id: id }).then((res) => {
          if (res.data.status == 1) {
            if (res.data.data.date) {
              res.data.data.date = moment(new Date(res.data.data.date)).format(
                "DD/MM/YYYY"
              );
            }
            if (res.data.data.lr_date) {
              res.data.data.lr_date = moment(
                new Date(res.data.data.lr_date)
              ).format("DD/MM/YYYY");
            }
            setInvoice(res.data.data);
          } else {
            toast.error(res.data.data, { autoClose: 3000 });
          }
          setLoading(false);
        });
    };

    useEffect(() => {
        if (id) {
          getEdit();
        }
      }, [id]);

    const printEstimate = () => {
        setTimeout(() => {
            window.print();
        }, 300);
    };

    const calculateTotalWeight = () => {
        // Calculate weight based on items - if weight field is not available, 
        // you may need to adjust this based on your product data structure
        return invoice.items?.reduce((total, item) => {
            const weight = parseFloat(item.product?.weight || item.weight || 0) * parseFloat(item.qty || 0);
            return total + weight;
        }, 0) || 0;
    };

    const getTotalItems = () => {
        return invoice.items?.reduce((total, item) => {
            return total + parseFloat(item.qty || 0);
        }, 0) || 0;
    };

    return (
        <>
          <div className="row">
            <div className="col-6 no-print">
              <h1>Dispatch</h1>
            </div>
            <div className="col-6 no-print">
              <div className="d-flex align-items-center justify-content-end">
                <button 
                  onClick={printEstimate} 
                  className="btn btn-primary mr-2"
                >
                  Print
                </button>
                <Link to={"/sales/invoices"} className="btn btn-dark">
                  Back
                </Link>
              </div>
            </div>
            <div className="col-md-12">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="estimate-container" style={{ 
                  backgroundColor: "#fff", 
                  padding: "20px",
                  marginTop: "20px",
                  fontSize: "18px",
                  fontWeight: 500,
                  textTransform: "uppercase"
                }}>

                  {/* Header */}
                  <div style={{ border: "1px solid #000", padding: "15px" }}>
                    <div>
                        <h2 style={{ 
                        margin: 0, 
                        padding: 0,
                        fontSize: "24px",
                        fontWeight: "bold"
                        }}>
                        DISPATCH
                        </h2>
                        <div style={{ marginTop: "5px", fontSize: "18px", }}>
                        <strong>Date:</strong> {invoice.date || ""}
                        </div>
                    </div>
                  </div>

                  {/* Main Content */}
                  <div style={{ 
                    display: "flex", 
                    borderLeft: "1px solid #000",
                    borderRight: "1px solid #000",
                    fontSize: "18px",
                    textTransform: "uppercase"
                  }}>
                    {/* Left Column - Consignee Info */}
                    <div style={{ 
                      width: "50%", 
                      paddingLeft: "20px",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      borderRight: "1px solid #000"
                    }}>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Name & Address of Consignee</strong>
                      </div>
                      <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                        {invoice.party?.name || ""}
                      </div>
                      <div style={{ marginBottom: "5px" }}>
                        {invoice.party?.address || ""}
                      </div>
                      {invoice.party?.city_name && (
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.party.city_name}
                          {invoice.party?.state_name && `, ${invoice.party.state_name}`}
                          {invoice.party?.pincode && `, ${invoice.party.pincode}`}
                        </div>
                      )}
                      {invoice.party?.gst_no && (
                        <div style={{ marginTop: "10px" }}>
                          <strong>GST:</strong> {invoice.party.gst_no}
                        </div>
                      )}
                    </div>

                    {/* Right Column - Shipped To & Transport */}
                    <div style={{ 
                      width: "50%", 
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      paddingLeft: "20px",
                      fontSize: "18px"
                    }}>
                      <div style={{ marginBottom: "15px" }}>
                        <div style={{ marginBottom: "10px" }}>
                          <strong>Details of Consignee (Shipped To)</strong>
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.ship_name || invoice.party?.name || ""}
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.ship_address_one || invoice.party?.address || ""}
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                            {invoice?.shipcity?.name ?? invoice.party?.city_name}
                            {invoice.party?.state_name && `, ${invoice.party.state_name}`}
                            {invoice.ship_pincode ?? invoice.party?.pincode ? `, ${invoice.party.pincode}` : ""}
                        </div>
                      </div>

                      <div style={{ marginTop: "15px", borderTop: "1px solid #ccc", paddingTop: "10px" }}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "3px 0", width: "80px" }}>
                                <strong>Transport:</strong>
                              </td>
                              <td style={{ padding: "3px 0" }}>
                                <span className="bill_transport" style={{ textTransform: "capitalize" }}>
                                  {invoice?.transport?.name ?? ""}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "3px 0", width: "80px" }}>
                                <strong>Vehicle No:</strong>
                              </td>
                              <td style={{ padding: "3px 0", width: "130px" }}>
                                {invoice.vehicle_no || ""}
                              </td>
                              <td style={{ padding: "3px 0", width: "50px" }}>
                                <strong>LR No:</strong>
                              </td>
                              <td style={{ padding: "3px 0" }}>
                                {invoice.lr_no || ""}
                              </td>
                              <td style={{ padding: "3px 0", width: "70px" }}>
                                <strong>LR Date:</strong>
                              </td>
                              <td style={{ padding: "3px 5px", width: "70px" }}>
                                {invoice.lr_date || ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Product Table */}
                  <div>
                    <table style={{ 
                      width: "100%", 
                      borderCollapse: "collapse",
                      border: "1px solid #000",
                      fontSize: "18px",
                      textTransform: "uppercase"
                    }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "50px"
                          }}>
                            #
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left"
                          }}>
                            Product
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "150px"
                          }}>
                            Qty
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.items?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center"
                            }}>
                              {index + 1}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.product?.name} {item.subproduct?.name ? ` - ${item.subproduct?.name}` : ""} {item.subproduct?.size?.name ? ` - ${item.subproduct?.size?.name}` : ` - ${item.product?.size?.name}`} {item.product?.supplier ? ` - ${item.product?.supplier.name}` : ""}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.qty} {item.unit || item.product?.unit || "Box"}
                            </td>
                          </tr>
                        ))}
                        <tr>
                        <td colSpan="2"></td>
                          <td style={{ textAlign: "left", padding: "10px 0px" }}>
                            <div>
                                <strong>{getTotalItems()} Items</strong>
                            </div>
                            <div>
                                <strong>{calculateTotalWeight().toFixed(2)} KG</strong>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      );

};

export default Dispatch;